/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_Reset_Password_SubmitInputs */

const en_common_sign_reset_password_submit = /** @type {(inputs: Common_Sign_Reset_Password_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset password`)
};

const zh_common_sign_reset_password_submit = /** @type {(inputs: Common_Sign_Reset_Password_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重置密码`)
};

/**
* | output |
* | --- |
* | "Reset password" |
*
* @param {Common_Sign_Reset_Password_SubmitInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_sign_reset_password_submit = /** @type {((inputs?: Common_Sign_Reset_Password_SubmitInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Reset_Password_SubmitInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_sign_reset_password_submit(inputs)
	return zh_common_sign_reset_password_submit(inputs)
});
export { common_sign_reset_password_submit as "common.sign.reset_password_submit" }